import { Star, StarHalf } from '@phosphor-icons/react'

export default function StarRating({ rating }: { rating: number }) {
  const stars = []

  for (let i = 0; i < 5; i++) {
    stars.push(
      <li key={i} className="text-yellow-600">
        <RatingStar rating={rating - i} />
      </li>
    )
  }

  return (
    <div className="flex space-x-2">
      <p className="text-xl font-black" aria-hidden="true">
        {rating}
      </p>
      <ol
        aria-label={`${rating} von 5 Sterne`}
        className="flex items-center space-x-px"
      >
        {stars}
      </ol>
    </div>
  )
}

function RatingStar({ rating }: { rating: number }) {
  if (rating < 0.25) {
    return <Star size={20} />
  }

  if (rating < 0.75) {
    return <StarHalf size={20} weight="fill" />
  }

  return <Star size={20} weight="fill" />
}
